export const LOGIN = "sessions/LOGIN";
export const UPDATE = "sessions/UPDATE";
export const LOGIN_ERROR = "sessions/LOGIN_ERROR";
export const PUSH_ID = "sessions/PUSH_ID";
export const CLEAR = "sessions/CLEAR";
export const REFRESH_CARTS = "sessions/REFRESH_CARTS";
export const REFRESH_CACHED_SALES_CARTS = "sessions/REFRESH_CACHED_SALES_CARTS";
export const SET_CARTS = "sessions/SET_CARTS";
export const SET_LOCATIONS = "sessions/SET_LOCATIONS";
export const SET_SETTINGS = "sessions/SET_SETTINGS";



// WEBPACK FOOTER //
// ./app/modules/session/actionTypes.js